import { adminFetch } from "./_client";
import type { AdminPrefs, SavedView } from "./types";

export function fetchAdminPrefs(token: string) {
  return adminFetch<{ prefs: AdminPrefs }>(`/admin/me/prefs`, token);
}

export function updateAdminPrefs(token: string, patch: Partial<Omit<AdminPrefs, "user_id" | "updated_at">>) {
  return adminFetch<{ prefs: AdminPrefs }>(`/admin/me/prefs`, token, {
    method: "PATCH",
    body: JSON.stringify(patch),
  });
}

export function fetchSavedViews(token: string, section?: string) {
  const suffix = section ? `?section=${encodeURIComponent(section)}` : "";
  return adminFetch<{ views: SavedView[] }>(`/admin/saved-views${suffix}`, token);
}

export function createSavedView(token: string, payload: { section: string; name: string; query: string; is_shared?: boolean; is_default?: boolean }) {
  return adminFetch<{ view: SavedView }>(`/admin/saved-views`, token, {
    method: "POST",
    body: JSON.stringify(payload),
  });
}

export function updateSavedView(
  token: string,
  id: number,
  patch: Partial<{ name: string; query: string; is_shared: boolean; is_default: boolean }>,
) {
  return adminFetch<{ view: SavedView }>(`/admin/saved-views/${id}`, token, {
    method: "PATCH",
    body: JSON.stringify(patch),
  });
}

export function deleteSavedView(token: string, id: number) {
  return adminFetch<{ success: true }>(`/admin/saved-views/${id}`, token, { method: "DELETE" });
}
